import React from "react";
import { FiStar } from "react-icons/fi";

/**
 * Five stars, either read-only or clickable.
 *
 * Passing `onChange` makes it a control: the stars become buttons, so a rating
 * can be given from the keyboard as well as the mouse.
 */
export default function StarRating({ value = 0, onChange = null, size = 18, label = "" }) {
  const stars = [1, 2, 3, 4, 5];

  if (!onChange) {
    return (
      <div className="flex items-center gap-0.5" aria-label={`${value} out of 5 stars`}>
        {stars.map((star) => (
          <FiStar
            key={star}
            size={size}
            className={star <= value ? "text-amber-400" : "text-slate-300"}
            fill={star <= value ? "currentColor" : "none"}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1" role="radiogroup" aria-label={label || "Rating"}>
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} star${star === 1 ? "" : "s"}`}
          onClick={() => onChange(star)}
          className="rounded p-0.5 transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <FiStar
            size={size}
            className={star <= value ? "text-amber-400" : "text-slate-300"}
            fill={star <= value ? "currentColor" : "none"}
          />
        </button>
      ))}
    </div>
  );
}
